import { useState } from "react";
import {
  AlertDialogModel,
  EnumAlertDialogType,
  EnumPopupFunctions,
  PopupInfoModel,
  UserModel,
} from "../Managers/dataStructures";
import { confirmPassword } from "../Managers/wepApiManager";
import { getLanguage } from "../Managers/dataProvider";

interface TLLoginDialogProps {
  user: UserModel;
  item: PopupInfoModel;
  props?: any;
  redirectDialog: (item: PopupInfoModel) => void;
  closeDialog: () => void;
}

export default function TLLoginDialog(props: TLLoginDialogProps) {
  let [password_] = useState<string>();
  const isEnglish = getLanguage();

  function onCancel() {
    props.closeDialog();
  }

  async function onProceed() {
    const pass: string = password_ !== undefined ? password_ : "";
    //const isSuccess: boolean = await confirmPassword(props.user, pass);
    confirmPassword(props.user, pass, (isSuccess: boolean) => {
      if (isSuccess === false) {
        const alert: AlertDialogModel = {
          type: EnumAlertDialogType.NEGATIVE,
          alert_title: "Invalid password",
          alert_description:
            "Enterd password is incorrect. Please enter the correct password.",
          dismiss_button_text: "Dismiss Alert",
        };
        const item_: PopupInfoModel = {
          item: alert,
          props: props.props,
          ftype: EnumPopupFunctions.ALERT_DIALOG,
        };
        props.redirectDialog(item_);
      } else {
        switch (props.item.ftype) {
          case EnumPopupFunctions.TL_USER_LOGIN_DIALOG:
            props.redirectDialog(props.item);
            break;
          case EnumPopupFunctions.TL_FORCE_CLOSE_DIALOG:
            if (props.item.callback !== undefined) {
              props.item.callback(props.item.item);
            }
            break;
          case EnumPopupFunctions.TL_END_SHIFT_DIALOG:
            if (props.item.callback !== undefined) {
              props.item.callback(props.item.item);
            }

            break;
          case EnumPopupFunctions.MAIN_MENU_PASSWORD_REQUIRED_LOGIN_DIALOG:
            if (props.item.callback !== undefined) {
              props.item.callback(props.item.item);
            }
            break;
        }
      }
    });
  }

  function onPassword(value: string) {
    password_ = value;
  }

  return (
    <div className="bg-white shadow sm:rounded-lg">
      <div className="px-4 py-5 sm:p-6">
        <h3 className="text-base font-semibold leading-6 text-gray-900">
          {props.user.email_id}
        </h3>
        <div className="mt-2 max-w-xl text-sm text-gray-500">
          <p>
            {isEnglish
              ? "Please enter password to proceed."
              : "Bitte Passwort eingeben, um fortzufahren"}
          </p>
        </div>
        <div className="mt-5 sm:flex sm:items-center">
          <div className="w-full sm:max-w-xs">
            <label htmlFor="email" className="sr-only">
              {isEnglish ? "Password" : "Password"}
            </label>
            <input
              type="password"
              name="password"
              id="password"
              autoComplete="password"
              onChange={(x) => onPassword(x.currentTarget.value)}
              className="block w-full font-semibold rounded-md border-0 py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              placeholder={
                isEnglish ? "Enter Password" : "Bitte Passwort eingeben"
              }
            />
          </div>
          <button
            type="submit"
            onClick={onProceed}
            className="mt-3 inline-flex w-full items-center justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:ml-3 sm:mt-0 sm:w-auto"
          >
            {isEnglish ? "Proceed" : "Weiter"}
          </button>
          <button
            onClick={onCancel}
            type="button"
            className="text-sm font-semibold leading-6 text-gray-900 mx-5"
          >
            {isEnglish ? "Cancel" : "Stornieren"}
          </button>
        </div>
      </div>
    </div>
  );
}
